import ButtonComp from "@components/UI/Button/Index.jsx";
import SelectOptionComp from "@components/UI/SelectOption/Index.jsx"
import { emailTypes } from "@enums/TemplatesEmail/Index.jsx";
import { useEffect, useState } from "react";
import TipoEmail from "@components/UI/TipoEmail/Index.jsx";
import InputTextComp from "@components/UI/InputText/Index";

// Valores iniciais alinhados com os filtros disponíveis
const initialValues = {
    nome: "",
    tipoEmail: "",
};

const Filter = ({ filters, setFilters, templates }) => {

    const [tempValues, setTempValues] = useState(initialValues);

    const handleTempChange = (field, value) => {
        setTempValues((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSearch = (e) => {
        e.preventDefault();

        setFilters({
            nome: tempValues.nome,
            tipoEmail: tempValues.tipoEmail?.value,
        });
    };

    // Limpa filtros
    const handleClearFilter = () => {
        setTempValues(initialValues);
        setFilters(initialValues);
    };

    return (
        <div className="form">
            <div className="row py-3">

                <div className="col-8 col-md-8">

                    <InputTextComp
                        label={"Nome Template"}
                        value={tempValues.nome}
                        onChange={e => handleTempChange("nome", e.target.value)}
                        placeholder={"Preencher o nome do template"}
                        hoverMessage={"Preencher o nome do template"}
                    />

                    <SelectOptionComp
                        label={"Tipo E-mail"}
                        options={emailTypes}
                        value={tempValues.tipoEmail}
                        onChange={(selected) => handleTempChange("tipoEmail", selected)}
                        placeholder="Selecionar o tipo do e-mail"
                        hoverMessage="Selecionar o tipo do e-mail"
                    />

                </div>

                <div className="col-8 mt-4 d-flex justify-content-end">

                    <ButtonComp
                        title="APLICAR FILTRO"
                        buttonColor={"#2b97be"}
                        classnameIcon={"fa-solid fa-filter"}
                        hoverMessage={"Botão para aplicar o filtro da consulta"}
                        onClick={handleSearch}
                    />

                    <ButtonComp
                        title="LIMPAR FILTRO"
                        buttonColor={"#125578"}
                        classnameIcon={"fa-regular fa-circle-xmark"}
                        hoverMessage={"Botão para limpar os campos de filtros preenchidos"}
                        onClick={handleClearFilter}
                        type={"button"}
                    />

                </div>

            </div>
        </div>
    );
}

export default Filter;